//
//
//
//
//
//
//
//
//
var script = {
  name: 'SelectOption',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: undefined
    },
    selectedId: {
      type: [String, Number],
      default: undefined
    },
    currentSuggestionIndex: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    isSelected() {
      return this.selectedId === this.option.id;
    },

    current() {
      return this.currentSuggestionIndex === this.index;
    }

  },
  watch: {
    current(isCurrent) {
      if (isCurrent) {
        this.$nextTick(() => {
          if (!this.$refs.option) return;
          const isMicrosoftBrowser = new RegExp(['MSIE ', 'Edge/'].join('|')).test(navigator.userAgent);
          if (isMicrosoftBrowser) return;
          this.$refs.option.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });
      }
    }

  },
  methods: {
    onOptionSelected() {
      this.$emit('option-selected', this.option);
    },

    onMouseOver() {
      this.$emit('mouseover', this.index);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/SelectOption.vue_rollup-plugin-vue=script.js